<template>
  <pt-goods-qr-code-detail class="pt-goods-qr-code-detail__withData" :id="id" @downloadQrCodeDetail="downloadQrCodeDetail" @getQrCodeUrl="getQrCodeUrl"
  :revieQrCodeUrl="revieQrCodeUrl"></pt-goods-qr-code-detail>
</template>

<script>
import PtGoodsQrCodeDetail from './index'
export default {
  name: 'pt-goods-qr-code-detail__withData',
  components: {
    'pt-goods-qr-code-detail': PtGoodsQrCodeDetail
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      revieQrCodeUrl: null
    }
  },
  methods: {
    downloadQrCodeDetail (id) {
      this.$store.dispatch('downloadQrCodeDetail', id).then(res => {
        this.$message.success('下载二维码成功')
      }).catch(err => {
        this.$message.error(err || '下载二维码失败')
      })
    },
    getQrCodeUrl (url) {
      let data = {
        resourcePath: url
      }
      this.revieQrCodeUrl = null
      this.$store.dispatch('getResuorceUrl', data).then(res => {
        this.revieQrCodeUrl = res
      })
    }
  }
}
</script>
